import React from 'react';
import { Switch } from '@mui/material';
import { styled } from '@mui/material/styles';
import { brandSwitchStyles } from '../ManageEvent/components/manageEventFieldStyles';

const PublishedSwitch = styled(Switch)(brandSwitchStyles);

const EventPublishedSwitch = ({ checked, onChange, disabled = false, inputProps }) => (
  <PublishedSwitch
    checked={Boolean(checked)}
    onChange={onChange}
    disabled={disabled}
    inputProps={inputProps}
  />
);

export default EventPublishedSwitch;
